import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectSections } from '../grid/reduxStore/editorSlice';
import Section from './Section';
import type { ActiveDraggedSectionInfo } from './types';
import useActiveSection from './useActiveSection';
import { useReorderSectionsHandler } from '../hooks/useReorderSectionsHandler.ts';

export default function SectionsList() {
  const sections = useSelector(selectSections);
  const { reorder } = useReorderSectionsHandler(sections);
  const { activeSection } = useActiveSection();

  const draggedRef = useRef<ActiveDraggedSectionInfo | null>(null);

  return (
    <Box
      data-testid="sections-list-side-panel"
      width="100%"
      height="100%"
      paddingTop="1.25rem"
      paddingRight="0.6rem"
      paddingBottom="1.25rem"
      sx={{ overflowY: 'auto' }}
    >
      <List>
        {sections.map((section, index) => (
          <Section
            index={index}
            key={section.id}
            title={section.title}
            id={section.id}
            isActive={activeSection === section.id}
            onReorder={reorder}
            draggedRef={draggedRef}
            isLast={index === sections.length - 1}
          />
        ))}
      </List>
    </Box>
  );
}
